import React from "react";
import PropTypes from "prop-types";
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon
} from "react-share";

const Social = ({ shareUrl, title }) => (
  <div style={{ display: "inline-flex", cursor: "pointer" }}>
    <FacebookShareButton
      url={shareUrl}
      quote={title}
      className="Demo__some-network__share-button"
    >
      <FacebookIcon size={32} round />
    </FacebookShareButton>

    <TwitterShareButton
      url={shareUrl}
      title={title}
      className="Demo__some-network__share-button"
    >
      <TwitterIcon size={32} round />
    </TwitterShareButton>

    <LinkedinShareButton
      url={shareUrl}
      title={title}
      windowWidth={750}
      windowHeight={600}
      className="Demo__some-network__share-button"
    >
      <LinkedinIcon size={32} round />
    </LinkedinShareButton>

    <EmailShareButton
      url={shareUrl}
      subject="Peux-tu m'aider à progresser en évaluant mon pitch ?"
      body={`Peux-tu m'aider à progresser en évaluant mon pitch ? ${shareUrl}`}
      className="Demo__some-network__share-button"
    >
      <EmailIcon size={32} round />
    </EmailShareButton>
  </div>
);

Social.propTypes = {
  shareUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default Social;
